<template>
	<div class="big">
		<ul >
			<li v-for="(item,index) in userList" @click="clickEvents(item.id,item.category)">
				<span class="span1" v-text="item.title"></span>
				<span style="float: right;">
					<img style="width: 0.12rem; height: 0.2rem;" src="../../../assets/xiayb.png" />
				</span>
			</li>
		</ul>
	</div>
		
</template>
<script>
	import request from '@/utils/request'
	export default {
		components: {

		},
		data() {
			return {
					userList: [],
			}
		},
		created() {
			this.initData()
		},
		methods: {
			initData() {
				let _this = this;
				//let url = Global.env + Global.apiCore.subsystemEnterprises+"/"+this.relationId;
				let url = Global.env + Global.apiCore.helpList;
				return new Promise((resolve, reject) => {
					request({
						url: url,
						method: 'get', //查询一般为get
					}).then(response => {
						if (response.resultCode === "1000") {
							console.log('*************')
							console.log(response.data)
							_this.userList = response.data;
							return resolve()
						}
					}).catch(error => {
						return reject(error);
					})
				})
			},
			clickEvents(a,b) {
				if(b == '1'){
					this.$router.push({
						name: 'UserDetails',
						query: {
							id: a,
						}
					})
				}else if(b == '2'){
					this.$router.push({
						name: 'UserDetails1',
						query: {
							id: a,
						}
					})
				}
			},
		}
	}
</script>

<style scoped>
	.big {
		width: 100%;
		text-align: justify;
	}
	
	ul{
		width: 92%;
		height: auto;
		margin: 0 auto;
	}
	li{
		height: 1.1rem;
		line-height: 1.1rem;
		margin: 0 auto;
		border-bottom:1px solid rgba(243,243,244,1);
		color: #333333;
		font-size: 0.32rem;
		background: url(../../../assets/bangz.png)no-repeat left center;
		background-size:0.33rem 0.34rem ;
		padding-left: 0.5rem;
		
	}
	.span1{
		/* display: inline-block; */
		float: left;
		width: 84%;
		overflow: hidden;text-overflow: ellipsis; display: -webkit-box;-webkit-line-clamp: 1;-webkit-box-orient: vertical;
	}
</style>
